import React, { useState, useEffect, useRef } from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button,
    Row, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { getCheckRegisters } from '../../API';
import CheckRegisterCard from './CheckRegisterCard';
import CheckRegisterSelectedTag from './CheckRegisterSelectedTag';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle as farTimesCircle } from '@fortawesome/free-regular-svg-icons'
import { faTimesCircle, faEye, faEdit, faEllipsisH, faEnvelope, faMapMarkerAlt, faCity, faUser, faAsterisk, faDollarSign, faBan, faHashtag, faUsers, faCalendarAlt, faFileAlt, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';

function CheckRegisterSelect(props) {
    const [selectedChecks, setSelectedChecks] = useState([]);
    const [checks, setChecks] = useState([]);
    const [title, setTitle] = useState(props.multiple ? 'Select Checks' : 'Select Check');
    const [searchOptions, setSearchOptions] = useState({ ...props.searchOptions });
    const searchOptionsRef = useRef(searchOptions);
    const [isLoading, setIsLoading] = useState(true);
    searchOptionsRef.current = searchOptions;

    useEffect(() => {
        const timeoutSearch = async () => {
            await search();
        };

        const timeout = setTimeout(timeoutSearch, 500);

        return (() => clearTimeout(timeout));
    }, [searchOptions]);

    const defaultCheckRegisterCardOptions = {
        fields: {
            division: true,
            feeType: true,
            checkFrom: true,
            checkNumber: true,
            amount: true,
            checkDate: true,
            receivedDate: true,
            comments: true
        },
        actions: {
            view: false,
            select: true,
            cancel: false
        }
    };

    const checkRegisterCardOptions = { ...defaultCheckRegisterCardOptions, ...props.checkRegisterCardOptions }

    const search = async () => {
        setIsLoading(true);

        const query = buildQuery(searchOptionsRef.current);
        const searchAPIResults = await getCheckRegisters(query);
        setChecks(searchAPIResults);

        setIsLoading(false);
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    const buildQuery = searches => {
        const query = { 'q.orderBy': 'RecdDate desc' };
        const whereOptions = [];
        if (searches) {
            for (let prop in searches) {
                if (searches[prop]) {
                    if (prop === "CheckNum") {
                        whereOptions.push(prop + " = " + searches[prop]);
                    } else {
                        whereOptions.push(prop + " like '%" + searches[prop] + "%'");
                    }
                }
            }

            if (whereOptions.length > 0) {
                const whereClause = whereOptions.join(' and ');
                query['q.where'] = whereClause;
            }
        }

        return query;
    };

    const select = (check) => {
        if (props.multiple) {
            if (!selectedChecks.some(c => c.PK_ID === check.PK_ID))
                setSelectedChecks([...selectedChecks, check]);
        } else {
            setSelectedChecks([check]);
        }
    };

    const deselect = (checkId) => {
        setSelectedChecks(selectedChecks.filter(o => o.PK_ID !== checkId));
    };

    const selectChecks = () => {
        props.toggle();
        setSearchOptions({ ...props.searchOptions });
        props.select(props.multiple ? selectedChecks : (selectedChecks.length > 0 ? selectedChecks[0] : null));
        setSelectedChecks([]);
    };

    const cancel = () => {
        props.toggle();
        setSearchOptions({ ...props.searchOptions });
        setSelectedChecks([]);
    };

    const selectedList = selectedChecks.map(sc => {
        return (<CheckRegisterSelectedTag check={sc} key={sc.PK_ID} cancel={deselect} />);
    });

    const checksList = checks.map(c => {
        return (<CheckRegisterCard check={c} key={c.PK_ID} select={select} deselect={deselect} selected={selectedChecks.some(s => s.PK_ID === c.PK_ID)} options={checkRegisterCardOptions} />);
    });

    return (
        <Modal isOpen={props.open} toggle={props.toggle} size="xl">
            <ModalHeader>
                {title}
            </ModalHeader>
            <ModalBody>
                <div className="search">
                    <Row xs={1} md={2} lg={3} xl={3}>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUsers} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="DANR Program" name="Program" value={searchOptions.Program || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faHashtag} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Check Number" name="CheckNum" value={searchOptions.CheckNum || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faArrowCircleRight} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Payment For" name="FeeType" value={searchOptions.FeeType || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Check From" name="CheckFrom" value={searchOptions.CheckFrom || ''} onChange={updateSearch} />
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="selected-list">
                    {selectedList}
                </div>
                <div className="record-list">
                    {checksList}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className="btn-icon" color="danr-red" onClick={cancel}><FontAwesomeIcon icon={farTimesCircle} /><span>Cancel</span></Button>
                <Button className="btn-icon" color="danr-green" onClick={selectChecks}><FontAwesomeIcon icon={faCheckCircle} /><span>Select</span></Button>
            </ModalFooter>
        </Modal>
    );
}

export default CheckRegisterSelect;